import React, {FormEvent, useCallback, useRef} from "react"
import {TIsUrlSaleOrClearance} from "../../models/Request"

export type UseSearchBoxProps = {
    searchTerm: string
    onTyping: (chars: string) => void
    onSubmit: (siteUrl: string, saleOrClearance: string, searchTerm: string) => void
    inputSearchRef?: HTMLInputElement
    siteUrl: string
    saleOrClearance: TIsUrlSaleOrClearance["saleOrClearance"]
}

const handleEmptySpace = (val: string) => (!val?.trim() ? "" : val)

export const useSearchBox = ({
    searchTerm,
    onSubmit,
    onTyping,
    inputSearchRef,
    siteUrl,
    saleOrClearance,
}: UseSearchBoxProps) => {
    const searchRef = useRef(inputSearchRef || null)

    const handleChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => onTyping(handleEmptySpace(e.target.value)),

        [onTyping],
    )

    const handleSubmit = useCallback(
        (event: FormEvent<HTMLFormElement>) => {
            event.preventDefault()
            const cleanSearchTerm = searchTerm.toLowerCase().trim()
            const hasChars = cleanSearchTerm.length > 0
            if (hasChars) onSubmit(siteUrl, saleOrClearance, cleanSearchTerm)
        },

        [saleOrClearance, onSubmit, searchTerm, siteUrl],
    )

    const handleClear = useCallback(() => {
        onTyping("")
    }, [onTyping])

    const setTextInputRef = (element: HTMLInputElement) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        searchRef.current = element
    }

    return {
        handleClear,
        handleChange,
        handleSubmit,
        setTextInputRef,
    }
}
